var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"error-page"},[_c('div',[_c('h1',{attrs:{"data-h1":"404"}},[_vm._v("404")]),_c('p',{attrs:{"data-p":"PAGE NOT FOUND"}},[_vm._v("PAGE NOT FOUND")]),_c('a',{staticClass:"back",attrs:{"href":"/"}},[_vm._v("GO BACK HOME")])])])])
}]
render._withStripped = true
export { render, staticRenderFns }